import About from './About';

export default About;



// WEBPACK FOOTER //
// ./src/About/index.js